export default function NovelCard({ novel, votes }) {
    return (
        <div className="novel-card">
            <img
                src={novel.coverUrl}
                alt={novel.title}
                className="cover"
            />

            <h3>{novel.title}</h3>

            <div className="vote-count">
                {votes} votes
            </div>
        </div>
    );
}
